export const INITDATA = 'INITDATA';
export const FILTERBYNAME = 'FILTERBYNAME';
export const DEFAULT_THEME = 'DEFAULT_THEME';
export const WHITETHEME = 'WHITETHEME';
export const DARKTHEME = 'DARKTHEME';

